// extracted by mini-css-extract-plugin
export default {"header":"header_header__x8oeZ","header_logo":"header_header_logo__np7fV","logo":"header_logo__E5XQy"};